import {Star} from 'lucide-react'
import { useWatchlist } from '@/hooks/useWatchlist'

interface WatchButtonProps {
  projectId: string
  projectName: string
  compact?: boolean
}

function WatchButton({ projectId, projectName, compact = false }: WatchButtonProps) {
  const { isWatched, toggle, address } = useWatchlist()
  const watched = isWatched(projectId)
  const canWatch = Boolean(address?.trim())

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        if (!canWatch)
          return
        toggle(projectId)
      }}
      disabled={!canWatch}
      aria-pressed={watched}
      aria-label={canWatch
        ? (watched ? `Remove ${projectName} from watchlist` : `Add ${projectName} to watchlist`)
        : 'Connect a wallet to save a watchlist to that address'}
      className={compact
        ? `flex h-8 w-8 items-center justify-center rounded-full border transition-colors ${
          !canWatch
            ? 'cursor-not-allowed border-white/10 bg-black/40 text-zinc-600'
            : watched
              ? 'border-lime-400/40 bg-lime-400/15 text-lime-400'
              : 'border-white/10 bg-black/40 text-zinc-500 hover:border-white/20 hover:text-white'
        }`
        : `inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
          !canWatch
            ? 'cursor-not-allowed border-white/10 bg-black/40 text-zinc-600'
            : watched
              ? 'border-lime-400/40 bg-lime-400/15 text-lime-400'
              : 'border-white/10 bg-black/40 text-zinc-400 hover:border-white/20 hover:text-white'
        }`}
    >
      <Star className={`h-3.5 w-3.5 ${watched ? 'fill-lime-400 text-lime-400' : ''}`} aria-hidden="true" />
      {compact ? null : (watched ? 'Watching' : 'Watch')}
    </button>
  )
}

export default WatchButton
